import { render, staticRenderFns } from "./teacherTab.vue?vue&type=template&id=5a70f92c"
import script from "./teacherTab.vue?vue&type=script&lang=js"
export * from "./teacherTab.vue?vue&type=script&lang=js"
import style0 from "./teacherTab.vue?vue&type=style&index=0&id=5a70f92c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports